import { Badge, BadgeColor, type TableRow } from "@prequel/shared-components";

import type { ProductResource } from "@/api/import/products";
import { SYSTEM_PRODUCT_NAME, useListProducts } from "@/api/import/products";
import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Destinations", "Created"];

const mapProductToRow = (product: ProductResource): TableRow => ({
  id: product.id,
  to: `/import/destinations/products/${product.id}`,
  cells: [
    {
      value: (
        <span className="flex items-center gap-2">
          {product.name}
          {product.name === SYSTEM_PRODUCT_NAME && <Badge text="system" color={BadgeColor.GRAY} />}
        </span>
      ),
    },
    { value: product.destinations.join(", ") || "—" },
    { value: <Timestamp timestamp={product.created_at} /> },
  ],
});

const ProductsTable = () => {
  return (
    <ResourceTable<ProductResource>
      columns={COLUMNS}
      useQuery={useListProducts}
      rowMapper={mapProductToRow}
      emptyMessage="No products configured."
    />
  );
};

export default ProductsTable;
